<template>
  <section class="c-section-block">
    <header class="c-section-block__header" v-if="!headerHidden" :class="{'no-padd':noPadding}">
      <div class="c-section-block__header-main" :style="headerMainStyle">
        <slot name="header"></slot>
      </div>
      <div class="c-section-block__header-actions">
        <slot name="actions"></slot>
      </div>
      <div class="c-section-block__header__toggle" v-if="mobileToggle">
        <button @click="handleToggle" type="button" :class="{'is-open': isOpen}">
          <span class="screen-reader-text">{{ isOpen ? 'Close' : 'Open' }}</span>
        </button>
      </div>
    </header>

    <div class="c-section-block__main" :class="{'u-no-pad-sm':noPadding}">
      <slot></slot>
    </div>

    <footer class="c-section-block__footer">
      <slot name="footer"></slot>
    </footer>
  </section>
</template>

<script>
export default {
  name: "section-block",

  props: {
    headerOverflowHidden: Boolean,
    headerHidden: Boolean,
    mobileToggle: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    headerMainStyle() {
      if (this.headerOverflowHidden) {
        return {
          overflow: "hidden"
        };
      }

      return false;
    }
  },
  methods: {
    handleToggle() {
      this.isOpen = !this.isOpen;
      this.$emit("mobile-toggle");
    }
  }
};
</script>

<style lang="scss">
.c-section-block {
  background: $colour-nhs-white;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  display: block;
  // widows: 100%;
  position: relative;
  margin-bottom: 0;
  height: 100%;
  // z-index: 10;
}

.c-section-block__main {
  padding: 10px;

  @media screen and (min-width: 1024px) {
    padding: 1em;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  &.u-no-pad-sm {
    padding: 0;

    @media (min-width: 768px) {
      padding: 1em;
    }
  }
}

.c-section-block__header {
  border-bottom: 1px solid $colour-nhs-pale-grey;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 20px;
    color: $colour-nhs-dark-grey;
  }

  .c-button {
    margin: 0;
  }

  .c-button:not(:last-of-type) {
    margin-right: 1em;
  }

  padding: 0.75em;
  &.no-padd {
    padding: 0 0 0 0.75em;

    @media (min-width: 768px) {
      padding: 0.75em;
    }
  }

  &__toggle {
    button {
      font-size: 35px;
      appearance: none;
      border: none;
      border-left: 1px solid $colour-nhs-med-grey;
      width: 62px;
      height: 55px;
      display: inline-flex;
      align-content: center;
      justify-content: center;
      color: $colour-nhs-med-grey;
      background: transparent;
      position: relative;

      &:after {
        position: absolute;
        right: 50%;
        top: 50%;
        content: "";
        border: 5px solid transparent;
        border-top-color: $colour-nhs-blue;
        transform: rotate(-90deg);
        transition: all ease-in-out 0.2s;
        transform-origin: top center;
      }

      &.is-open {
        &:after {
          transform: rotate(0);
          transform: translateY(-1px);
        }
      }
    }

    @media (min-width: 768px) {
      display: none;
    }
  }
}

.c-section-block__header-main {
  flex-grow: 0;
  width: 100%;
}

.c-section-block__header-actions {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: flex-end;
  align-self: flex-start;

  @media screen and (min-width: 1024px) {
    // display: flex;
  }
}

.c-section-block--fixed-height {
  height: 700px;
}

.header-central .c-section-block__header-actions {
  align-self: center;
}
</style>
